var api = {
  "files": [
    {
      "name": "happyco/api/public/inspect/template/v1/template.proto",
      "description": "",
      "package": "happyco.inspect.template.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "CreateTemplatesRequest",
          "longName": "CreateTemplatesRequest",
          "fullName": "happyco.inspect.template.v1.CreateTemplatesRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "templates",
              "description": "",
              "label": "repeated",
              "type": "Template",
              "longType": "Template",
              "fullType": "happyco.inspect.template.v1.Template",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateTemplatesResponse",
          "longName": "CreateTemplatesResponse",
          "fullName": "happyco.inspect.template.v1.CreateTemplatesResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "template_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListTemplatesRequest",
          "longName": "ListTemplatesRequest",
          "fullName": "happyco.inspect.template.v1.ListTemplatesRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "template_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "archived",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListTemplatesResponse",
          "longName": "ListTemplatesResponse",
          "fullName": "happyco.inspect.template.v1.ListTemplatesResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "templates",
              "description": "",
              "label": "repeated",
              "type": "Template",
              "longType": "Template",
              "fullType": "happyco.inspect.template.v1.Template",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "previous_page",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "next_page",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SetTemplatesArchivedRequest",
          "longName": "SetTemplatesArchivedRequest",
          "fullName": "happyco.inspect.template.v1.SetTemplatesArchivedRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "template_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SetTemplatesArchivedResponse",
          "longName": "SetTemplatesArchivedResponse",
          "fullName": "happyco.inspect.template.v1.SetTemplatesArchivedResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "Template",
          "longName": "Template",
          "fullName": "happyco.inspect.template.v1.Template",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "edition",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "description",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "sections",
              "description": "",
              "label": "repeated",
              "type": "SectionsEntry",
              "longType": "Template.SectionsEntry",
              "fullType": "happyco.inspect.template.v1.Template.SectionsEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "outlines",
              "description": "",
              "label": "repeated",
              "type": "OutlinesEntry",
              "longType": "Template.OutlinesEntry",
              "fullType": "happyco.inspect.template.v1.Template.OutlinesEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "rating_groups",
              "description": "",
              "label": "repeated",
              "type": "RatingGroupsEntry",
              "longType": "Template.RatingGroupsEntry",
              "fullType": "happyco.inspect.template.v1.Template.RatingGroupsEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "header_fields",
              "description": "",
              "label": "repeated",
              "type": "HeaderField",
              "longType": "happyco.inspect.type.v1.HeaderField",
              "fullType": "happyco.inspect.type.v1.HeaderField",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "footer_fields",
              "description": "",
              "label": "repeated",
              "type": "FooterField",
              "longType": "happyco.inspect.type.v1.FooterField",
              "fullType": "happyco.inspect.type.v1.FooterField",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "OutlinesEntry",
          "longName": "Template.OutlinesEntry",
          "fullName": "happyco.inspect.template.v1.Template.OutlinesEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "StringArray",
              "longType": "happyco.type.v1.StringArray",
              "fullType": "happyco.type.v1.StringArray",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingGroupsEntry",
          "longName": "Template.RatingGroupsEntry",
          "fullName": "happyco.inspect.template.v1.Template.RatingGroupsEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "RatingGroup",
              "longType": "happyco.inspect.type.v1.RatingGroup",
              "fullType": "happyco.inspect.type.v1.RatingGroup",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SectionsEntry",
          "longName": "Template.SectionsEntry",
          "fullName": "happyco.inspect.template.v1.Template.SectionsEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "Section",
              "longType": "happyco.inspect.type.v1.Section",
              "fullType": "happyco.inspect.type.v1.Section",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateTemplatesRequest",
          "longName": "UpdateTemplatesRequest",
          "fullName": "happyco.inspect.template.v1.UpdateTemplatesRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "templates",
              "description": "",
              "label": "repeated",
              "type": "Template",
              "longType": "Template",
              "fullType": "happyco.inspect.template.v1.Template",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateTemplatesResponse",
          "longName": "UpdateTemplatesResponse",
          "fullName": "happyco.inspect.template.v1.UpdateTemplatesResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        }
      ],
      "services": [
        {
          "name": "TemplateService",
          "longName": "TemplateService",
          "fullName": "happyco.inspect.template.v1.TemplateService",
          "description": "",
          "methods": [
            {
              "name": "ListTemplates",
              "description": "",
              "requestType": "ListTemplatesRequest",
              "requestLongType": "ListTemplatesRequest",
              "requestFullType": "happyco.inspect.template.v1.ListTemplatesRequest",
              "requestStreaming": false,
              "responseType": "ListTemplatesResponse",
              "responseLongType": "ListTemplatesResponse",
              "responseFullType": "happyco.inspect.template.v1.ListTemplatesResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/templates/list",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "CreateTemplates",
              "description": "",
              "requestType": "CreateTemplatesRequest",
              "requestLongType": "CreateTemplatesRequest",
              "requestFullType": "happyco.inspect.template.v1.CreateTemplatesRequest",
              "requestStreaming": false,
              "responseType": "CreateTemplatesResponse",
              "responseLongType": "CreateTemplatesResponse",
              "responseFullType": "happyco.inspect.template.v1.CreateTemplatesResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/templates/create",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateTemplates",
              "description": "",
              "requestType": "UpdateTemplatesRequest",
              "requestLongType": "UpdateTemplatesRequest",
              "requestFullType": "happyco.inspect.template.v1.UpdateTemplatesRequest",
              "requestStreaming": false,
              "responseType": "UpdateTemplatesResponse",
              "responseLongType": "UpdateTemplatesResponse",
              "responseFullType": "happyco.inspect.template.v1.UpdateTemplatesResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/inspect/templates/update",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "ArchiveTemplates",
              "description": "",
              "requestType": "SetTemplatesArchivedRequest",
              "requestLongType": "SetTemplatesArchivedRequest",
              "requestFullType": "happyco.inspect.template.v1.SetTemplatesArchivedRequest",
              "requestStreaming": false,
              "responseType": "SetTemplatesArchivedResponse",
              "responseLongType": "SetTemplatesArchivedResponse",
              "responseFullType": "happyco.inspect.template.v1.SetTemplatesArchivedResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/inspect/templates/archive",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UnarchiveTemplates",
              "description": "",
              "requestType": "SetTemplatesArchivedRequest",
              "requestLongType": "SetTemplatesArchivedRequest",
              "requestFullType": "happyco.inspect.template.v1.SetTemplatesArchivedRequest",
              "requestStreaming": false,
              "responseType": "SetTemplatesArchivedResponse",
              "responseLongType": "SetTemplatesArchivedResponse",
              "responseFullType": "happyco.inspect.template.v1.SetTemplatesArchivedResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/inspect/templates/unarchive",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "name": "happyco/api/public/inspect/inspection/v1/inspection.proto",
      "description": "",
      "package": "happyco.inspect.inspection.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [
        {
          "name": "Status",
          "longName": "InspectionStatusChangesEvent.InspectionStatusChange.Status",
          "fullName": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent.InspectionStatusChange.Status",
          "description": "",
          "values": [
            {
              "name": "SCHEDULED",
              "number": "0",
              "description": ""
            },
            {
              "name": "IN_PROGRESS",
              "number": "1",
              "description": ""
            },
            {
              "name": "COMPLETED",
              "number": "2",
              "description": ""
            }
          ]
        }
      ],
      "extensions": [],
      "messages": [
        {
          "name": "AddInspectionPhotoRequest",
          "longName": "AddInspectionPhotoRequest",
          "fullName": "happyco.inspect.inspection.v1.AddInspectionPhotoRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspection_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "file_name",
              "description": "File name must include a valid image extension.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "data",
              "description": "Data should contain the image data.",
              "label": "",
              "type": "bytes",
              "longType": "bytes",
              "fullType": "bytes",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AddInspectionPhotoResponse",
          "longName": "AddInspectionPhotoResponse",
          "fullName": "happyco.inspect.inspection.v1.AddInspectionPhotoResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "photo_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "error",
              "description": "Error contains an error response for a request or an empty string.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AddInspectionPhotosRequest",
          "longName": "AddInspectionPhotosRequest",
          "fullName": "happyco.inspect.inspection.v1.AddInspectionPhotosRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "requests",
              "description": "Requests to be performed. The responses will be an array of the\nsame length and order.",
              "label": "repeated",
              "type": "AddInspectionPhotoRequest",
              "longType": "AddInspectionPhotoRequest",
              "fullType": "happyco.inspect.inspection.v1.AddInspectionPhotoRequest",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AddInspectionPhotosResponse",
          "longName": "AddInspectionPhotosResponse",
          "fullName": "happyco.inspect.inspection.v1.AddInspectionPhotosResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "responses",
              "description": "Responses is an array of the same length and order as the requests.",
              "label": "repeated",
              "type": "AddInspectionPhotoResponse",
              "longType": "AddInspectionPhotoResponse",
              "fullType": "happyco.inspect.inspection.v1.AddInspectionPhotoResponse",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateDelegatedInspectionLinkRequest",
          "longName": "CreateDelegatedInspectionLinkRequest",
          "fullName": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinkRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "email",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "first_name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "last_name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspection_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "expiry",
              "description": "",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateDelegatedInspectionLinkResponse",
          "longName": "CreateDelegatedInspectionLinkResponse",
          "fullName": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinkResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "link",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "error",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateDelegatedInspectionLinksRequest",
          "longName": "CreateDelegatedInspectionLinksRequest",
          "fullName": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinksRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "requests",
              "description": "",
              "label": "repeated",
              "type": "CreateDelegatedInspectionLinkRequest",
              "longType": "CreateDelegatedInspectionLinkRequest",
              "fullType": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinkRequest",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "send_email",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "email_subject_template",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "email_template_html",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "email_template_text",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateDelegatedInspectionLinksResponse",
          "longName": "CreateDelegatedInspectionLinksResponse",
          "fullName": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinksResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "responses",
              "description": "",
              "label": "repeated",
              "type": "CreateDelegatedInspectionLinkResponse",
              "longType": "CreateDelegatedInspectionLinkResponse",
              "fullType": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinkResponse",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateInspectionsRequest",
          "longName": "CreateInspectionsRequest",
          "fullName": "happyco.inspect.inspection.v1.CreateInspectionsRequest",
          "description": "Create Inspection request can be used to create new valid scheduled, in\nprogress or completed inspections. Two inspections cannot have the same\nexternal ID and all must be valid for the request to complete. This includes\narchived inspection IDs.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspections",
              "description": "Inspections to be created.",
              "label": "repeated",
              "type": "Inspection",
              "longType": "Inspection",
              "fullType": "happyco.inspect.inspection.v1.Inspection",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateInspectionsResponse",
          "longName": "CreateInspectionsResponse",
          "fullName": "happyco.inspect.inspection.v1.CreateInspectionsResponse",
          "description": "Create Inspection response contains a list of inspection ids (including\nhappyco internal ids) for inspections created with a create inspection\nrequest.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "inspection_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Inspection",
          "longName": "Inspection",
          "fullName": "happyco.inspect.inspection.v1.Inspection",
          "description": "Inspection represents an inspection in its 3 states: scheduled, in_progress\nand completed.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": true,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "ID of inspection.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "account_id",
              "description": "Account ID that the inspection belongs to.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_id",
              "description": "Asset is the parent that inspection is attached to. This field must\nreference a non archived asset in the same folder as the template\nreferenced below.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "template_id",
              "description": "Template is the prototype of an inspection thats allow it to be\nconfigured on the fly. This field must reference a non archived\ntemplate in the same folder as the parent asset referenced above.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "template_outline",
              "description": "Template outline when set on a scheduled inspection forces a\ndifferent outline prototype to be used when the inspection moves\nfrom scheduled to in_progress.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "scheduled",
              "description": "",
              "label": "",
              "type": "ScheduledInspection",
              "longType": "ScheduledInspection",
              "fullType": "happyco.inspect.inspection.v1.ScheduledInspection",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "status",
              "defaultValue": ""
            },
            {
              "name": "in_progress",
              "description": "",
              "label": "",
              "type": "InspectionData",
              "longType": "InspectionData",
              "fullType": "happyco.inspect.inspection.v1.InspectionData",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "status",
              "defaultValue": ""
            },
            {
              "name": "completed",
              "description": "",
              "label": "",
              "type": "InspectionData",
              "longType": "InspectionData",
              "fullType": "happyco.inspect.inspection.v1.InspectionData",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "status",
              "defaultValue": ""
            },
            {
              "name": "update_time",
              "description": "",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "photo_quality",
              "description": "Photo Quality is an override setting sent to clients that informs\nthem what level of Photo Quality they should enforce, regardless of\nuser settings on the client. The default value is 0 which denotes that\nthe client should use the user's settings, otherwise the higher the value\nthe higher Photo Quality should be enforced by the client.",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "assigned_to_id",
              "description": "Inspector ID is an optional field that specifies the user assigned to\nperform the inspection.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "metadata",
              "description": "Metadata is a map of key value pairs that can be used to store\nadditional data about the inspection.",
              "label": "repeated",
              "type": "MetadataEntry",
              "longType": "Inspection.MetadataEntry",
              "fullType": "happyco.inspect.inspection.v1.Inspection.MetadataEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "due_by",
              "description": "Due by is an optional field that contains the expected due date of the\ninspection.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "MetadataEntry",
          "longName": "Inspection.MetadataEntry",
          "fullName": "happyco.inspect.inspection.v1.Inspection.MetadataEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "InspectionData",
          "longName": "InspectionData",
          "fullName": "happyco.inspect.inspection.v1.InspectionData",
          "description": "Inspection data has fields containing all of the inspection data for an\ninspection with a status of in_progress or completed.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "started_at",
              "description": "Started at is a non optional field that is set to the actual time\nthat an inspection transitions from scheduled to in_progress. This\ntime comes from the device where the transition occurs on as the\nuser may be offline.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "ended_at",
              "description": "Ended at is an optional field for in_progress inspections but\nrequired for completed inspections. It is set to the actual time\nthat an inspection transtions from in_progress to complete. This\ntime comes from the device where the transition occurs as the suer\nmay be offline.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "user_started_at",
              "description": "User started at is an optional field that can appear on reports.\nThis can be updated by the user to a specific time. When an\ninspection transitions from scheduled to in_progress the\nschedule_date becomes this field.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "user_ended_at",
              "description": "User ended at is an optional field that can appear on reports.\nThis can be updated by the user to a specific time.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "header_fields",
              "description": "HeaderFields are shown on the top of an inspection and reports\ngenerated from it.",
              "label": "repeated",
              "type": "HeaderField",
              "longType": "happyco.inspect.type.v1.HeaderField",
              "fullType": "happyco.inspect.type.v1.HeaderField",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "sections",
              "description": "Sections and their items hold most of the inspection data; selected\nratings, notes, and photos.",
              "label": "repeated",
              "type": "Section",
              "longType": "happyco.inspect.type.v1.Section",
              "fullType": "happyco.inspect.type.v1.Section",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "footer_fields",
              "description": "FooterFields are shown at the end of an inspection and reports\ngenerated from it.",
              "label": "repeated",
              "type": "FooterField",
              "longType": "happyco.inspect.type.v1.FooterField",
              "fullType": "happyco.inspect.type.v1.FooterField",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "rating_groups",
              "description": "Rating groups is a map of unique keys within an inspection to\nrating groups. Each item within this inspection must reference a\nrating group with a key in this map.",
              "label": "repeated",
              "type": "RatingGroupsEntry",
              "longType": "InspectionData.RatingGroupsEntry",
              "fullType": "happyco.inspect.inspection.v1.InspectionData.RatingGroupsEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingGroupsEntry",
          "longName": "InspectionData.RatingGroupsEntry",
          "fullName": "happyco.inspect.inspection.v1.InspectionData.RatingGroupsEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "RatingGroup",
              "longType": "happyco.inspect.type.v1.RatingGroup",
              "fullType": "happyco.inspect.type.v1.RatingGroup",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "InspectionStatusChangesEvent",
          "longName": "InspectionStatusChangesEvent",
          "fullName": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent",
          "description": "Inspection status change events are emitted from streams requested with\nOnInspectionStatusChanges.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "event",
              "description": "",
              "label": "",
              "type": "Event",
              "longType": "happyco.type.v1.Event",
              "fullType": "happyco.type.v1.Event",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "changes",
              "description": "",
              "label": "repeated",
              "type": "InspectionStatusChange",
              "longType": "InspectionStatusChangesEvent.InspectionStatusChange",
              "fullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent.InspectionStatusChange",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "InspectionStatusChange",
          "longName": "InspectionStatusChangesEvent.InspectionStatusChange",
          "fullName": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent.InspectionStatusChange",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "inspection_id",
              "description": "Inspection ID can be used to fetch the inspection with a\nfiltered list inspections request",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "from_status",
              "description": "From status is the status prior to the change event.",
              "label": "",
              "type": "Status",
              "longType": "InspectionStatusChangesEvent.InspectionStatusChange.Status",
              "fullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent.InspectionStatusChange.Status",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "to_status",
              "description": "To status is the status post the change event.",
              "label": "",
              "type": "Status",
              "longType": "InspectionStatusChangesEvent.InspectionStatusChange.Status",
              "fullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent.InspectionStatusChange.Status",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "InspectionStatusChangesEventAck",
          "longName": "InspectionStatusChangesEventAck",
          "fullName": "happyco.inspect.inspection.v1.InspectionStatusChangesEventAck",
          "description": "Inspection status changes event ack is used to acknowledge or request time\nextensions for one or more events.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "ack",
              "description": "See EventAck for more details.",
              "label": "",
              "type": "EventAck",
              "longType": "happyco.type.v1.EventAck",
              "fullType": "happyco.type.v1.EventAck",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "InspectionStatusChangesEventAckResponse",
          "longName": "InspectionStatusChangesEventAckResponse",
          "fullName": "happyco.inspect.inspection.v1.InspectionStatusChangesEventAckResponse",
          "description": "InspectionStatusChangeEventAckResponse contains no data but indicates\nsuccessful acknowledgement.",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "InspectionStatusChangesEventRequest",
          "longName": "InspectionStatusChangesEventRequest",
          "fullName": "happyco.inspect.inspection.v1.InspectionStatusChangesEventRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "options",
              "description": "Options the client can set to configure the returned event stream.\nSee EventHandlerOptions for more details.\n\nfiltering maybe later?\n repeated type.v1.IntegrationID folder_ids = 2;\n repeated type.v1.IntegrationID inspection_ids = 3;\n string status = 4;",
              "label": "",
              "type": "EventHandlerOptions",
              "longType": "happyco.type.v1.EventHandlerOptions",
              "fullType": "happyco.type.v1.EventHandlerOptions",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListInspectionsRequest",
          "longName": "ListInspectionsRequest",
          "fullName": "happyco.inspect.inspection.v1.ListInspectionsRequest",
          "description": "List inspection request is used for fetching inspections. It can be\nfiltered to specific inspections, assets or folders. If the intent is to be\nnotified when an inspection undergoes a status transition please use the\nInspectionEventService.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_ids",
              "description": "Folder IDs is an optional filter that lists inspections only for\nspecific folders.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_ids",
              "description": "Asset IDs is an optional filter that lists inspections only for\nspecific assets.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspection_ids",
              "description": "Inspection IDs  is an optional filter that lists only specific\ninspections. This is commonly used to get a single inspection.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "archived",
              "description": "Archived when set to true returns archived inspections only.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "Paging message that contains information about the page being\nrequested. This message is usually copied from a previous list\nrequest's response.",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "min_update_time",
              "description": "",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "max_update_time",
              "description": "",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListInspectionsResponse",
          "longName": "ListInspectionsResponse",
          "fullName": "happyco.inspect.inspection.v1.ListInspectionsResponse",
          "description": "List inspection response is a page of fetched inspection results. It\nincludes a previous and next page token that can be passed into subsequent\nlist inspection requests.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "inspections",
              "description": "Inspections contains the results for this page.",
              "label": "repeated",
              "type": "Inspection",
              "longType": "Inspection",
              "fullType": "happyco.inspect.inspection.v1.Inspection",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "previous_page",
              "description": "Previous page is an token that will be present for all pages after\nthe first.",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "next_page",
              "description": "Next page is an token that will be present for all pages except the\nlast.",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ScheduledInspection",
          "longName": "ScheduledInspection",
          "fullName": "happyco.inspect.inspection.v1.ScheduledInspection",
          "description": "Scheduled inspection is the message type for inspection status scheduled. It\ncan include a specific scheduled date for the inspection and overrides for\nheader and footer fields when the inspection status transitions to\nin_progress.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "schedule_date",
              "description": "Schedule date is an optional field that contians the expected start\ntime or due date of the inspection.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "header_fields",
              "description": "Header notes is an optional override that will be used instead of\nthe header fields defined by the template.",
              "label": "repeated",
              "type": "HeaderField",
              "longType": "happyco.inspect.type.v1.HeaderField",
              "fullType": "happyco.inspect.type.v1.HeaderField",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "footer_fields",
              "description": "Footer notes is an optional override that will be used instead of\nthe footer fields defined by the template.",
              "label": "repeated",
              "type": "FooterField",
              "longType": "happyco.inspect.type.v1.FooterField",
              "fullType": "happyco.inspect.type.v1.FooterField",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "sections",
              "description": "",
              "label": "repeated",
              "type": "Section",
              "longType": "happyco.inspect.type.v1.Section",
              "fullType": "happyco.inspect.type.v1.Section",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SetInspectionsArchivedRequest",
          "longName": "SetInspectionsArchivedRequest",
          "fullName": "happyco.inspect.inspection.v1.SetInspectionsArchivedRequest",
          "description": "SetInspectionsArchivedRequest is used to archive and unarchive  multiple inspections.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspection_ids",
              "description": "Inspection IDs that should be updated.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SetInspectionsArchivedResponse",
          "longName": "SetInspectionsArchivedResponse",
          "fullName": "happyco.inspect.inspection.v1.SetInspectionsArchivedResponse",
          "description": "SetInspectionsArchivedResponse contains no data and indicates success of\nthe operation.",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "UpdateInspectionsRequest",
          "longName": "UpdateInspectionsRequest",
          "fullName": "happyco.inspect.inspection.v1.UpdateInspectionsRequest",
          "description": "Update Inspection request can be used to update existing valid scheduled,\nin progress completed, and archived inspections. Two inspections cannot have\nthe same external ID and all must be valid for the request to complete. This\nincludes archived inspection IDs. An update cannot cause an inspection to\ntransition from in_progress to scheduled.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspections",
              "description": "Inspection to be updated.",
              "label": "repeated",
              "type": "Inspection",
              "longType": "Inspection",
              "fullType": "happyco.inspect.inspection.v1.Inspection",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateInspectionsResponse",
          "longName": "UpdateInspectionsResponse",
          "fullName": "happyco.inspect.inspection.v1.UpdateInspectionsResponse",
          "description": "Update inspection response contains no data and indicates success of all\nupdates.",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        }
      ],
      "services": [
        {
          "name": "InspectionEventService",
          "longName": "InspectionEventService",
          "fullName": "happyco.inspect.inspection.v1.InspectionEventService",
          "description": "InspectionEventService is the simplest way to be notified of inspection\nstatus changes. Any number of clients can connect to the service and be\npushed the events. HappyCo guarantees to only send one client the event at a\ntime (in a round robin fashion). This means that you can scale event\nprocessing as easily as your web servers.\n\nFor this to work events must be acknowledged or time extensions requested\nbefore the timeout peroid. If neither of these occurs, the event will be\nsent to a new client. This covers 99% of cases, but if it's essential that\nin the event of a frozen client (that unfreezes) that the event is not sent\nto another client. You can de-duplicate requests using the event ID.\n\nWhen selecting a timeout and possible requesting time extensions please be\nwary of network travel time. We recommend setting large timeouts (10mins+)\nunless there is a critical reason to be resent events faster.",
          "methods": [
            {
              "name": "OnInspectionStatusChanges",
              "description": "On inspection status changes returns a stream that will be pushed\nevents as they occur",
              "requestType": "InspectionStatusChangesEventRequest",
              "requestLongType": "InspectionStatusChangesEventRequest",
              "requestFullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEventRequest",
              "requestStreaming": false,
              "responseType": "InspectionStatusChangesEvent",
              "responseLongType": "InspectionStatusChangesEvent",
              "responseFullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEvent",
              "responseStreaming": true
            },
            {
              "name": "OnInspectionStatusChangesAck",
              "description": "On inspection status changes ack should be called when events have\nbeen processed. Unless this is called events will be sent again\nafter the timeout period.",
              "requestType": "InspectionStatusChangesEventAck",
              "requestLongType": "InspectionStatusChangesEventAck",
              "requestFullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEventAck",
              "requestStreaming": false,
              "responseType": "InspectionStatusChangesEventAckResponse",
              "responseLongType": "InspectionStatusChangesEventAckResponse",
              "responseFullType": "happyco.inspect.inspection.v1.InspectionStatusChangesEventAckResponse",
              "responseStreaming": false
            }
          ]
        },
        {
          "name": "InspectionService",
          "longName": "InspectionService",
          "fullName": "happyco.inspect.inspection.v1.InspectionService",
          "description": "Inspection service is used for creating, updating and archiving\ninspections. Unless otherwise noted all bulk methods occur inside of a\ntransaction and in the event of an error all requested changes on that\nmethod call will be rolled back.",
          "methods": [
            {
              "name": "ListInspections",
              "description": "List inspections gets a paginated and optionally filtered list of\ninspections from one or more folders.",
              "requestType": "ListInspectionsRequest",
              "requestLongType": "ListInspectionsRequest",
              "requestFullType": "happyco.inspect.inspection.v1.ListInspectionsRequest",
              "requestStreaming": false,
              "responseType": "ListInspectionsResponse",
              "responseLongType": "ListInspectionsResponse",
              "responseFullType": "happyco.inspect.inspection.v1.ListInspectionsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/inspections/list",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "CreateInspections",
              "description": "Create inspections can create inspections with any status (normally\nscheduled).",
              "requestType": "CreateInspectionsRequest",
              "requestLongType": "CreateInspectionsRequest",
              "requestFullType": "happyco.inspect.inspection.v1.CreateInspectionsRequest",
              "requestStreaming": false,
              "responseType": "CreateInspectionsResponse",
              "responseLongType": "CreateInspectionsResponse",
              "responseFullType": "happyco.inspect.inspection.v1.CreateInspectionsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/inspections/create",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateInspections",
              "description": "Update inspections can change the contents of inspections.\nCurrently an inspection cannot have its asset_id or template_id\nupdated.",
              "requestType": "UpdateInspectionsRequest",
              "requestLongType": "UpdateInspectionsRequest",
              "requestFullType": "happyco.inspect.inspection.v1.UpdateInspectionsRequest",
              "requestStreaming": false,
              "responseType": "UpdateInspectionsResponse",
              "responseLongType": "UpdateInspectionsResponse",
              "responseFullType": "happyco.inspect.inspection.v1.UpdateInspectionsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/inspect/inspections/update",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "ArchiveInspections",
              "description": "Archive inspections should be used to archive inspections that are no\nlonger wanted. No method for purging archived inspections is\navailable via the API. All inspections must belong to the same folder.",
              "requestType": "SetInspectionsArchivedRequest",
              "requestLongType": "SetInspectionsArchivedRequest",
              "requestFullType": "happyco.inspect.inspection.v1.SetInspectionsArchivedRequest",
              "requestStreaming": false,
              "responseType": "SetInspectionsArchivedResponse",
              "responseLongType": "SetInspectionsArchivedResponse",
              "responseFullType": "happyco.inspect.inspection.v1.SetInspectionsArchivedResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/inspect/inspections/archive",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UnarchiveInspections",
              "description": "Unarchive inspections should be used if previously archived\ninspections need to be restored. All inspections must belong\nto the same folder.",
              "requestType": "SetInspectionsArchivedRequest",
              "requestLongType": "SetInspectionsArchivedRequest",
              "requestFullType": "happyco.inspect.inspection.v1.SetInspectionsArchivedRequest",
              "requestStreaming": false,
              "responseType": "SetInspectionsArchivedResponse",
              "responseLongType": "SetInspectionsArchivedResponse",
              "responseFullType": "happyco.inspect.inspection.v1.SetInspectionsArchivedResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/inspect/inspections/unarchive",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "AddInspectionPhotos",
              "description": "No longer supported since 2.6.",
              "requestType": "AddInspectionPhotosRequest",
              "requestLongType": "AddInspectionPhotosRequest",
              "requestFullType": "happyco.inspect.inspection.v1.AddInspectionPhotosRequest",
              "requestStreaming": false,
              "responseType": "AddInspectionPhotosResponse",
              "responseLongType": "AddInspectionPhotosResponse",
              "responseFullType": "happyco.inspect.inspection.v1.AddInspectionPhotosResponse",
              "responseStreaming": false,
              "options": {
                "deprecated": true,
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/inspection/photos/add",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "CreateDelegatedInspectionLinks",
              "description": "",
              "requestType": "CreateDelegatedInspectionLinksRequest",
              "requestLongType": "CreateDelegatedInspectionLinksRequest",
              "requestFullType": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinksRequest",
              "requestStreaming": false,
              "responseType": "CreateDelegatedInspectionLinksResponse",
              "responseLongType": "CreateDelegatedInspectionLinksResponse",
              "responseFullType": "happyco.inspect.inspection.v1.CreateDelegatedInspectionLinksResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/inspection/links/create",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "name": "happyco/api/public/inspect/type/v1/inspect_type.proto",
      "description": "",
      "package": "happyco.inspect.type.v1",
      "hasEnums": true,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": false,
      "enums": [
        {
          "name": "RatingImage",
          "longName": "RatingImage",
          "fullName": "happyco.inspect.type.v1.RatingImage",
          "description": "",
          "values": [
            {
              "name": "UNDEFINED",
              "number": "0",
              "description": ""
            },
            {
              "name": "STAR_FULL",
              "number": "1",
              "description": ""
            },
            {
              "name": "STAR_HALF",
              "number": "2",
              "description": ""
            },
            {
              "name": "STAR_EMPTY",
              "number": "3",
              "description": ""
            },
            {
              "name": "TICK_ROUND",
              "number": "4",
              "description": ""
            },
            {
              "name": "CLEAN",
              "number": "5",
              "description": ""
            },
            {
              "name": "SCRATCHES",
              "number": "6",
              "description": ""
            },
            {
              "name": "SPLAT",
              "number": "7",
              "description": ""
            },
            {
              "name": "BROKEN",
              "number": "8",
              "description": ""
            },
            {
              "name": "TICK",
              "number": "9",
              "description": ""
            },
            {
              "name": "CROSS",
              "number": "10",
              "description": ""
            },
            {
              "name": "A",
              "number": "11",
              "description": ""
            },
            {
              "name": "B",
              "number": "12",
              "description": ""
            },
            {
              "name": "C",
              "number": "13",
              "description": ""
            },
            {
              "name": "D",
              "number": "14",
              "description": ""
            },
            {
              "name": "E",
              "number": "15",
              "description": ""
            },
            {
              "name": "F",
              "number": "16",
              "description": ""
            },
            {
              "name": "G",
              "number": "17",
              "description": ""
            },
            {
              "name": "H",
              "number": "18",
              "description": ""
            },
            {
              "name": "I",
              "number": "19",
              "description": ""
            },
            {
              "name": "J",
              "number": "20",
              "description": ""
            },
            {
              "name": "K",
              "number": "21",
              "description": ""
            },
            {
              "name": "L",
              "number": "22",
              "description": ""
            },
            {
              "name": "M",
              "number": "23",
              "description": ""
            },
            {
              "name": "N",
              "number": "24",
              "description": ""
            },
            {
              "name": "O",
              "number": "25",
              "description": ""
            },
            {
              "name": "P",
              "number": "26",
              "description": ""
            },
            {
              "name": "Q",
              "number": "27",
              "description": ""
            },
            {
              "name": "R",
              "number": "28",
              "description": ""
            },
            {
              "name": "S",
              "number": "29",
              "description": ""
            },
            {
              "name": "T",
              "number": "30",
              "description": ""
            },
            {
              "name": "U",
              "number": "31",
              "description": ""
            },
            {
              "name": "V",
              "number": "32",
              "description": ""
            },
            {
              "name": "W",
              "number": "33",
              "description": ""
            },
            {
              "name": "X",
              "number": "34",
              "description": ""
            },
            {
              "name": "Y",
              "number": "35",
              "description": ""
            },
            {
              "name": "Z",
              "number": "36",
              "description": ""
            },
            {
              "name": "DIGIT_0",
              "number": "37",
              "description": ""
            },
            {
              "name": "DIGIT_1",
              "number": "38",
              "description": ""
            },
            {
              "name": "DIGIT_2",
              "number": "39",
              "description": ""
            },
            {
              "name": "DIGIT_3",
              "number": "40",
              "description": ""
            },
            {
              "name": "DIGIT_4",
              "number": "41",
              "description": ""
            },
            {
              "name": "DIGIT_5",
              "number": "42",
              "description": ""
            },
            {
              "name": "DIGIT_6",
              "number": "43",
              "description": ""
            },
            {
              "name": "DIGIT_7",
              "number": "44",
              "description": ""
            },
            {
              "name": "DIGIT_8",
              "number": "45",
              "description": ""
            },
            {
              "name": "DIGIT_9",
              "number": "46",
              "description": ""
            },
            {
              "name": "EXCLAMATION",
              "number": "47",
              "description": ""
            },
            {
              "name": "QUESTION",
              "number": "48",
              "description": ""
            },
            {
              "name": "EXCLAMATION_QUESTION",
              "number": "49",
              "description": ""
            },
            {
              "name": "DOUBLE_EXCLAMATION",
              "number": "50",
              "description": ""
            },
            {
              "name": "DOLLAR",
              "number": "51",
              "description": ""
            },
            {
              "name": "POUND",
              "number": "52",
              "description": ""
            },
            {
              "name": "CENTS",
              "number": "53",
              "description": ""
            },
            {
              "name": "THUMBS_UP",
              "number": "54",
              "description": ""
            },
            {
              "name": "THUMBS_DOWN",
              "number": "55",
              "description": ""
            },
            {
              "name": "AWARD",
              "number": "56",
              "description": ""
            },
            {
              "name": "FEMALE",
              "number": "57",
              "description": ""
            },
            {
              "name": "MALE",
              "number": "58",
              "description": ""
            },
            {
              "name": "CALENDAR",
              "number": "59",
              "description": ""
            },
            {
              "name": "BUILDINGS",
              "number": "60",
              "description": ""
            },
            {
              "name": "BUILDING",
              "number": "61",
              "description": ""
            },
            {
              "name": "HOUSE",
              "number": "62",
              "description": ""
            },
            {
              "name": "NO_ENTRY",
              "number": "63",
              "description": ""
            },
            {
              "name": "DOG",
              "number": "64",
              "description": ""
            },
            {
              "name": "CAT",
              "number": "65",
              "description": ""
            },
            {
              "name": "RAT",
              "number": "66",
              "description": ""
            },
            {
              "name": "CIGARETTE",
              "number": "67",
              "description": ""
            },
            {
              "name": "NO_SMOKING",
              "number": "68",
              "description": ""
            },
            {
              "name": "POOP",
              "number": "69",
              "description": ""
            },
            {
              "name": "WEED",
              "number": "70",
              "description": ""
            },
            {
              "name": "GUN",
              "number": "71",
              "description": ""
            },
            {
              "name": "BROKEN_GLASS",
              "number": "72",
              "description": ""
            },
            {
              "name": "CRACKED",
              "number": "73",
              "description": ""
            },
            {
              "name": "DEAD_FACE",
              "number": "74",
              "description": ""
            },
            {
              "name": "HANDICAP",
              "number": "75",
              "description": ""
            },
            {
              "name": "BROKEN_HEART",
              "number": "76",
              "description": ""
            },
            {
              "name": "HEART",
              "number": "77",
              "description": ""
            },
            {
              "name": "SYRINGE",
              "number": "78",
              "description": ""
            },
            {
              "name": "CLOCK",
              "number": "79",
              "description": ""
            },
            {
              "name": "MUSIC_NOTE",
              "number": "80",
              "description": ""
            },
            {
              "name": "PLANT",
              "number": "81",
              "description": ""
            },
            {
              "name": "NOSE",
              "number": "82",
              "description": ""
            },
            {
              "name": "DROPLET",
              "number": "83",
              "description": ""
            },
            {
              "name": "ELECTRIC",
              "number": "84",
              "description": ""
            },
            {
              "name": "BUG",
              "number": "85",
              "description": ""
            },
            {
              "name": "ARROW_RIGHT",
              "number": "86",
              "description": ""
            },
            {
              "name": "ARROW_LEFT",
              "number": "87",
              "description": ""
            },
            {
              "name": "ARROW_UP",
              "number": "88",
              "description": ""
            },
            {
              "name": "ARROW_DOWN",
              "number": "89",
              "description": ""
            },
            {
              "name": "RECYCLE",
              "number": "90",
              "description": ""
            },
            {
              "name": "TRASH",
              "number": "91",
              "description": ""
            },
            {
              "name": "KEY",
              "number": "92",
              "description": ""
            },
            {
              "name": "LOCK",
              "number": "93",
              "description": ""
            },
            {
              "name": "UNLOCK",
              "number": "94",
              "description": ""
            },
            {
              "name": "CLOUD",
              "number": "95",
              "description": ""
            },
            {
              "name": "SUNSHINE",
              "number": "96",
              "description": ""
            },
            {
              "name": "PLUS",
              "number": "97",
              "description": ""
            },
            {
              "name": "MINUS",
              "number": "98",
              "description": ""
            },
            {
              "name": "TEXTFIELD",
              "number": "99",
              "description": ""
            },
            {
              "name": "METER",
              "number": "100",
              "description": ""
            },
            {
              "name": "CAR",
              "number": "101",
              "description": ""
            },
            {
              "name": "CHART",
              "number": "102",
              "description": ""
            },
            {
              "name": "WRENCH",
              "number": "103",
              "description": ""
            },
            {
              "name": "CALCULATOR",
              "number": "104",
              "description": ""
            },
            {
              "name": "CREDIT_CARD",
              "number": "105",
              "description": ""
            },
            {
              "name": "PAINTBRUSH",
              "number": "106",
              "description": ""
            },
            {
              "name": "ROLLER",
              "number": "107",
              "description": ""
            },
            {
              "name": "MOBILE",
              "number": "108",
              "description": ""
            },
            {
              "name": "FLAG",
              "number": "109",
              "description": ""
            },
            {
              "name": "DOOR_OPEN",
              "number": "110",
              "description": ""
            },
            {
              "name": "DOOR_SHUT",
              "number": "111",
              "description": ""
            },
            {
              "name": "BED",
              "number": "112",
              "description": ""
            },
            {
              "name": "SHOWER",
              "number": "113",
              "description": ""
            },
            {
              "name": "SMOKE_ALARM",
              "number": "114",
              "description": ""
            },
            {
              "name": "LIGHT_BULB",
              "number": "115",
              "description": ""
            },
            {
              "name": "SMILEY_HAPPY",
              "number": "116",
              "description": ""
            },
            {
              "name": "SMILEY_SAD",
              "number": "117",
              "description": ""
            }
          ]
        }
      ],
      "extensions": [],
      "messages": [
        {
          "name": "FooterField",
          "longName": "FooterField",
          "fullName": "happyco.inspect.type.v1.FooterField",
          "description": "Header fields exist at the end of inspections and reports generated from\nthem. They can be preset in scheduled inspections.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is required and is shown on both the inspection and reports.\nExample values include: File #, Key Number, etc.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "type",
              "description": "Type is required an must be set to 'text'.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "Value is optional and is shown on both the inspection and reports.\nIt can be changed during the inspection.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "HeaderField",
          "longName": "HeaderField",
          "fullName": "happyco.inspect.type.v1.HeaderField",
          "description": "Header fields exist at the top of inspections and reports generated from\nthem. They can be preset in scheduled inspections.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is required and is shown on both the inspection and reports.\nExample values include: File #, Key Number, etc.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "type",
              "description": "Type is required an must be set to 'text'.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "Value is optional and is shown on both the inspection and reports.\nIt can be changed during the inspection.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Item",
          "longName": "Item",
          "fullName": "happyco.inspect.type.v1.Item",
          "description": "Item contains most of the inspection information such as; selected rating\nvalues, notes and photos. The name of an item should make sense in context\nof the section which they are a child of. An item corresponds to an\nindividual inspection row within the inspection.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "name",
              "description": "Name is an optional field but should be set to something that makes\nsense in context of the parent section. For example; 'Kitchen':\n'Sink', 'Floor 1': 'Water Heater'.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "notes",
              "description": "Notes is an optional field where inspectors can type custom notes\n(optionally using SnapText) that pertain to this item.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "info",
              "description": "Info is an optional field that can be used to provide helpful\ninformation to the inspector. It is not shown on the report and is\nprimarily used to help training.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "photos",
              "description": "Photos data can be added with the AddInspectionPhotos api.",
              "label": "repeated",
              "type": "Photo",
              "longType": "Photo",
              "fullType": "happyco.inspect.type.v1.Photo",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "rating_group_key",
              "description": "Rating group key is a string that can be used to access a rating\ngroup from the parent inspection. A rating group must exist for this\nkey within the inspection for the value to be valid.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "values",
              "description": "Values are a map of rating keys and the selected value(s). That can\nbe referenced using the item's associated rating group.",
              "label": "repeated",
              "type": "ValuesEntry",
              "longType": "Item.ValuesEntry",
              "fullType": "happyco.inspect.type.v1.Item.ValuesEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "scores",
              "description": "Scores are a map of rating keys and the selected score(s). That can\nbe referenced using the item's associated rating group.",
              "label": "repeated",
              "type": "ScoresEntry",
              "longType": "Item.ScoresEntry",
              "fullType": "happyco.inspect.type.v1.Item.ScoresEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "task_work_category_id",
              "description": "Task work category ID is an optional field that can be used to assign a task to an\nitem. Note that this is only useful when a business has access to Tasks.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ScoresEntry",
          "longName": "Item.ScoresEntry",
          "fullName": "happyco.inspect.type.v1.Item.ScoresEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "FloatArray",
              "longType": "happyco.type.v1.FloatArray",
              "fullType": "happyco.type.v1.FloatArray",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ValuesEntry",
          "longName": "Item.ValuesEntry",
          "fullName": "happyco.inspect.type.v1.Item.ValuesEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "RatingValues",
              "longType": "RatingValues",
              "fullType": "happyco.inspect.type.v1.RatingValues",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Photo",
          "longName": "Photo",
          "fullName": "happyco.inspect.type.v1.Photo",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "url",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingCheckbox",
          "longName": "RatingCheckbox",
          "fullName": "happyco.inspect.type.v1.RatingCheckbox",
          "description": "Rating checkbox is the simplest control and can simply be toggled. When\ntoggled on the value and score will be set on the item with the rating\ncontrols key; when off no entries will be added to the item.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "Value is a required field that will be inserted into the item and\nshown on reports if the checkbox is toggled on.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "score",
              "description": "Score is an optional field that will be inserted into the item and\ncan be shown on reports if the checkbox is toggled on.",
              "label": "",
              "type": "float",
              "longType": "float",
              "fullType": "float",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "color",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "image",
              "description": "",
              "label": "",
              "type": "RatingImage",
              "longType": "RatingImage",
              "fullType": "happyco.inspect.type.v1.RatingImage",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "minimum_photos",
              "description": "Minimum Photos is the minimum number of photos required to fulfil an item that has this\ncheckbox selected.",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "required_ratings",
              "description": "Required ratings is a list of rating keys for which selecting this checkbox\nimplies that each rating requires a value.",
              "label": "repeated",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this checkbox should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingControl",
          "longName": "RatingControl",
          "fullName": "happyco.inspect.type.v1.RatingControl",
          "description": "Rating control describe a single control that a user can use to rate an item. There\nare currently 3 controls; a checkbox, radio group, and drop down.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": true,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "Key is a required field. It is used when a control has a selected\nvalue. The key and its selected value(s) will be inserted into an\nitem's values map field and the key and the selected score(s) will\nbe inserted into the item's scores map field. It is also the default\nstring displayed to the user unless custom label(s) are set (see each control type).",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "checkbox",
              "description": "",
              "label": "",
              "type": "RatingCheckbox",
              "longType": "RatingCheckbox",
              "fullType": "happyco.inspect.type.v1.RatingCheckbox",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            },
            {
              "name": "radio_group",
              "description": "",
              "label": "",
              "type": "RatingRadioGroup",
              "longType": "RatingRadioGroup",
              "fullType": "happyco.inspect.type.v1.RatingRadioGroup",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            },
            {
              "name": "drop_down",
              "description": "",
              "label": "",
              "type": "RatingDropDown",
              "longType": "RatingDropDown",
              "fullType": "happyco.inspect.type.v1.RatingDropDown",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            },
            {
              "name": "number",
              "description": "",
              "label": "",
              "type": "RatingNumber",
              "longType": "RatingNumber",
              "fullType": "happyco.inspect.type.v1.RatingNumber",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            },
            {
              "name": "percentage",
              "description": "",
              "label": "",
              "type": "RatingPercentage",
              "longType": "RatingPercentage",
              "fullType": "happyco.inspect.type.v1.RatingPercentage",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            },
            {
              "name": "currency_dollar",
              "description": "",
              "label": "",
              "type": "RatingCurrencyDollar",
              "longType": "RatingCurrencyDollar",
              "fullType": "happyco.inspect.type.v1.RatingCurrencyDollar",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            },
            {
              "name": "date",
              "description": "",
              "label": "",
              "type": "RatingDate",
              "longType": "RatingDate",
              "fullType": "happyco.inspect.type.v1.RatingDate",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "control_type",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingCurrencyDollar",
          "longName": "RatingCurrencyDollar",
          "fullName": "happyco.inspect.type.v1.RatingCurrencyDollar",
          "description": "Rating currency dollar represents an amount of money, in dollars. Entry\n  can include 2 decimal places.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this field should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingDate",
          "longName": "RatingDate",
          "fullName": "happyco.inspect.type.v1.RatingDate",
          "description": "Rating date is a calendar value. The values will be stored as an RFC\n3339 full date string.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this field should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingDropDown",
          "longName": "RatingDropDown",
          "fullName": "happyco.inspect.type.v1.RatingDropDown",
          "description": "Rating drop downs are currently mutually exclusive controls. They can have\nnone or one option selected. They differ from radio controls in that each\noption can have its own label.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "options",
              "description": "Options is a required field that muast have 2-16 elements that\nrepresent the possible mutually exclusive selections",
              "label": "repeated",
              "type": "RatingDropDownOption",
              "longType": "RatingDropDownOption",
              "fullType": "happyco.inspect.type.v1.RatingDropDownOption",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this drop down should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingDropDownOption",
          "longName": "RatingDropDownOption",
          "fullName": "happyco.inspect.type.v1.RatingDropDownOption",
          "description": "Rating drop down options represent one of the selectable options in a drop\ndown.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override the value as the\ndefaul option to be displayed to the user for this option. This is\nuseful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "Value is a required field that will be inserted into the item and\nshown on reports if this radio option is selected. No two options in\nthe same drop down can have the same value.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "score",
              "description": "Score is an optional field that will be inserted into the item and\ncan be shown on reports if this drop down option is selected.",
              "label": "",
              "type": "float",
              "longType": "float",
              "fullType": "float",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "color",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "image",
              "description": "",
              "label": "",
              "type": "RatingImage",
              "longType": "RatingImage",
              "fullType": "happyco.inspect.type.v1.RatingImage",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "minimum_photos",
              "description": "Minimum Photos is the minimum number of photos required to fulfil an item that has this\ndrop down option selected.",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "required_ratings",
              "description": "Required ratings is a list of rating keys for which selecting this option\nimplies that each rating requires a value.",
              "label": "repeated",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingGroup",
          "longName": "RatingGroup",
          "fullName": "happyco.inspect.type.v1.RatingGroup",
          "description": "Rating groups have an optional label that can be useful for selecting a\nrating group during the item insert or update process. A rating group is\nwhat makes up the form controls for each item row in an inspection.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that can help users that need to update\ninspections on the fly.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "ratings",
              "description": "Ratings are the ordered set of rating controls an inspector sees\nfor an item that references this rating group.",
              "label": "repeated",
              "type": "RatingControl",
              "longType": "RatingControl",
              "fullType": "happyco.inspect.type.v1.RatingControl",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "requires_photo",
              "description": "Requires Photo is an optional map of Rating Control key to an\narray of Rating (Dropdown / Radio) Option value or Checkbox value\nfor all for all values that require a photo.\n\nDeprecated: set minimum_photos on the option instead.",
              "label": "repeated",
              "type": "RequiresPhotoEntry",
              "longType": "RatingGroup.RequiresPhotoEntry",
              "fullType": "happyco.inspect.type.v1.RatingGroup.RequiresPhotoEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": "",
              "options": {
                "deprecated": true
              }
            },
            {
              "name": "requires_note",
              "description": "Requires Note is an optional map of Rating Control key to an\narray of Rating (Dropdown / Radio) Option value or Checkbox value\nfor all for all values that require a notes",
              "label": "repeated",
              "type": "RequiresNoteEntry",
              "longType": "RatingGroup.RequiresNoteEntry",
              "fullType": "happyco.inspect.type.v1.RatingGroup.RequiresNoteEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "requires_value",
              "description": "Requires Value is an optional boolean for specifying that\nat least one rating value is required to be selected",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "requires_score",
              "description": "Require Score is an optional map of Rating Control key to an\narray of Rating (Dropdown / Radio) Option value or Checkbox value\nfor all for all values that require a score",
              "label": "repeated",
              "type": "RequiresScoreEntry",
              "longType": "RatingGroup.RequiresScoreEntry",
              "fullType": "happyco.inspect.type.v1.RatingGroup.RequiresScoreEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "minimum_photos",
              "description": "Minimum Photos is the minimum number of photos required to fulfil an item that has this\nrating group.",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RequiresNoteEntry",
          "longName": "RatingGroup.RequiresNoteEntry",
          "fullName": "happyco.inspect.type.v1.RatingGroup.RequiresNoteEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "StringArray",
              "longType": "happyco.type.v1.StringArray",
              "fullType": "happyco.type.v1.StringArray",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RequiresPhotoEntry",
          "longName": "RatingGroup.RequiresPhotoEntry",
          "fullName": "happyco.inspect.type.v1.RatingGroup.RequiresPhotoEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "StringArray",
              "longType": "happyco.type.v1.StringArray",
              "fullType": "happyco.type.v1.StringArray",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RequiresScoreEntry",
          "longName": "RatingGroup.RequiresScoreEntry",
          "fullName": "happyco.inspect.type.v1.RatingGroup.RequiresScoreEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "StringArray",
              "longType": "happyco.type.v1.StringArray",
              "fullType": "happyco.type.v1.StringArray",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingNumber",
          "longName": "RatingNumber",
          "fullName": "happyco.inspect.type.v1.RatingNumber",
          "description": "Rating numbers are entry fields for decimal numbers.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this field should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingPercentage",
          "longName": "RatingPercentage",
          "fullName": "happyco.inspect.type.v1.RatingPercentage",
          "description": "Rating percentages are entry fields for percentage values.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this field should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingRadioGroup",
          "longName": "RatingRadioGroup",
          "fullName": "happyco.inspect.type.v1.RatingRadioGroup",
          "description": "Rating radio group are mutually exclusive controls. They can have none or\none option selected.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "label",
              "description": "Label is an optional field that will override key as the user to be\ndisplayed. This is useful for localization of inspections.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "options",
              "description": "Options is a required field that muast have 2-6 elements that\nrepresent the possible mutually exclusive selections",
              "label": "repeated",
              "type": "RatingRadioGroupOption",
              "longType": "RatingRadioGroupOption",
              "fullType": "happyco.inspect.type.v1.RatingRadioGroupOption",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "exclude_from_total_score",
              "description": "Exclude from total score indicates that the score for this radio group should not be\nadded to the total score in reports.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingRadioGroupOption",
          "longName": "RatingRadioGroupOption",
          "fullName": "happyco.inspect.type.v1.RatingRadioGroupOption",
          "description": "Rating radio group option represent one of the toggles in a radio group.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "value",
              "description": "Value is a required field that will be inserted into the item and\nshown on reports if this radio option is selected. No two options in\nthe same radio group can have the same value.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "score",
              "description": "Score is an optional field that will be inserted into the item and\ncan be shown on reports if this radio option is selected.",
              "label": "",
              "type": "float",
              "longType": "float",
              "fullType": "float",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "color",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "image",
              "description": "",
              "label": "",
              "type": "RatingImage",
              "longType": "RatingImage",
              "fullType": "happyco.inspect.type.v1.RatingImage",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "minimum_photos",
              "description": "Minimum Photos is the minimum number of photos required to fulfil an item that has this\nradio group option selected.",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "required_ratings",
              "description": "Required ratings is a list of rating keys for which selecting this option\nimplies that each rating requires a value.",
              "label": "repeated",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "RatingValues",
          "longName": "RatingValues",
          "fullName": "happyco.inspect.type.v1.RatingValues",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": true,
          "extensions": [],
          "fields": [
            {
              "name": "scalar",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "rating_values",
              "defaultValue": ""
            },
            {
              "name": "array",
              "description": "",
              "label": "",
              "type": "StringArray",
              "longType": "happyco.type.v1.StringArray",
              "fullType": "happyco.type.v1.StringArray",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "rating_values",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Section",
          "longName": "Section",
          "fullName": "happyco.inspect.type.v1.Section",
          "description": "Sections provide structure to the inspection. Typically they'll have names\nlike 'Kitchen', 'Floor 1', etc.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "name",
              "description": "Section name is an optional field but should be set to something\nthat gives context to its items. The section name will be shown as a\nheader to the item names in inspections and reports.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "items",
              "description": "Items contain most of the inspection information such as; selected\nrating values, notes and photos.",
              "label": "repeated",
              "type": "Item",
              "longType": "Item",
              "fullType": "happyco.inspect.type.v1.Item",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": []
    },
    {
      "name": "happyco/api/public/inspect/report/v1/report.proto",
      "description": "",
      "package": "happyco.inspect.report.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "ListReportsRequest",
          "longName": "ListReportsRequest",
          "fullName": "happyco.inspect.report.v1.ListReportsRequest",
          "description": "List report request is used for fetching reports. It can be\nfiltered to specific reports, assets or folders. If the intent is to be\nnotified when an report undergoes a status transition please use the\nReportEventService.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_ids",
              "description": "Folder IDs is an optional filter that lists reports only for\nspecific folders.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_ids",
              "description": "Asset IDs is an optional filter that lists reports only for\nspecific assets.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspection_ids",
              "description": "Inspections IDs is an optional filter that lists reports only for\nspecific inspections.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "report_ids",
              "description": "Report IDs is an optional filter that lists reports only for\nspecific reports.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "archived",
              "description": "Archived when set to true returns archived reports only.",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "Paging message that contains information about the page being\nrequested. This message is usually copied from a previous list\nrequest's response.",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListReportsResponse",
          "longName": "ListReportsResponse",
          "fullName": "happyco.inspect.report.v1.ListReportsResponse",
          "description": "List reports response is a page of fetched report results. It\nincludes a previous and next page token that can be passed into subsequent\nlist report requests.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "reports",
              "description": "Reports contains the results for this page.",
              "label": "repeated",
              "type": "Report",
              "longType": "Report",
              "fullType": "happyco.inspect.report.v1.Report",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "previous_page",
              "description": "Previous page is an token that will be present for all pages after\nthe first.",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "next_page",
              "description": "Next page is an token that will be present for all pages except the\nlast.",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Report",
          "longName": "Report",
          "fullName": "happyco.inspect.report.v1.Report",
          "description": "Reports are the end artifact of one or sometimes two inspections. They are\ngenerated from inspection(s) at a point in time but do not update if the\nunderlying inspection updates. They are self contained once generated. They\nare intended to be similar to a printed pieice of paper in that they can't\nbe edited but they can be signed at any time.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "ID of report.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "public_url",
              "description": "Public URL can be used to share the inspection. It contains a UUID\nto provide security.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "name",
              "description": "Name of the asset that was inspected. This is typically the address\nof the unit or house that was inspected.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "title",
              "description": "Title of the report. This can be overriden by the user in the\nreport settings but typically comes from the template name used to\nperform the inspection.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "revision",
              "description": "The revision of the report. This will increment when a change\noccurs. Reports are limited to changes being archive/unarchive\noperations or new signatures being added.",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "account_id",
              "description": "Account ID that the report belongs to. For custom integrations\n(i.e. not integration partners) it may be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "FolderID references the folder that contains the inspections used to generate the report.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_id",
              "description": "Asset ID references the parent that inspection is attached to. This field must\nreference a non archived asset in the same folder as the template\nreferenced below.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspection_ids",
              "description": "Inspection IDs references one or more inspection(s) used to\ngenerate the report.",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "generated_at",
              "description": "Generated at is the time (as reported by the mobile device) that the\nreport was generated at.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "finalized_at",
              "description": "Finalized is the time (as reported by the mobile device) that the\nreport was locked. Until the report is locked the display settings\ncan be changed. Signing a report locks it immediately.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspector_id",
              "description": "Inspector ID references the user who completed the most\nrecent inspection used to generate the report.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inspector_name",
              "description": "Inspector name references the user who completed the most\nrecent inspection used to generate the report.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "data",
              "description": "All of the report data (this structure is still subject to change\nso at the moment this is just a json blob)\n\njson",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "signatories",
              "description": "A map of signatories added to the report. Each key in the map only\nneeds to be unique to this report.",
              "label": "repeated",
              "type": "SignatoriesEntry",
              "longType": "Report.SignatoriesEntry",
              "fullType": "happyco.inspect.report.v1.Report.SignatoriesEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SignatoriesEntry",
          "longName": "Report.SignatoriesEntry",
          "fullName": "happyco.inspect.report.v1.Report.SignatoriesEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "Signatory",
              "longType": "Signatory",
              "fullType": "happyco.inspect.report.v1.Signatory",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ReportsCreatedEvent",
          "longName": "ReportsCreatedEvent",
          "fullName": "happyco.inspect.report.v1.ReportsCreatedEvent",
          "description": "Reports created events are emitted from streams requested with\nOnReportCreated.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "event",
              "description": "",
              "label": "",
              "type": "Event",
              "longType": "happyco.type.v1.Event",
              "fullType": "happyco.type.v1.Event",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "reports",
              "description": "",
              "label": "repeated",
              "type": "ReportCreated",
              "longType": "ReportsCreatedEvent.ReportCreated",
              "fullType": "happyco.inspect.report.v1.ReportsCreatedEvent.ReportCreated",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ReportCreated",
          "longName": "ReportsCreatedEvent.ReportCreated",
          "fullName": "happyco.inspect.report.v1.ReportsCreatedEvent.ReportCreated",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "report_id",
              "description": "Report ID can be used to fetch the report with a filtered\nlist reports request",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "version",
              "description": "TODO: should we remove this? I feel like is only useful if we have an updated event stream too",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ReportsCreatedEventAck",
          "longName": "ReportsCreatedEventAck",
          "fullName": "happyco.inspect.report.v1.ReportsCreatedEventAck",
          "description": "Reports created event ack is used to acknowledge or request time extensions\nfor one or more events.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "ack",
              "description": "",
              "label": "",
              "type": "EventAck",
              "longType": "happyco.type.v1.EventAck",
              "fullType": "happyco.type.v1.EventAck",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ReportsCreatedEventAckResponse",
          "longName": "ReportsCreatedEventAckResponse",
          "fullName": "happyco.inspect.report.v1.ReportsCreatedEventAckResponse",
          "description": "ReportsCreatedEventAckResponse contains no data but indicates successful\nacknowledgement.",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "ReportsCreatedEventRequest",
          "longName": "ReportsCreatedEventRequest",
          "fullName": "happyco.inspect.report.v1.ReportsCreatedEventRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "Account ID that the request applies to. For custom integrations\n(i.e. not integration partners) it can be omitted.",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "options",
              "description": "Options the client can set to configure the returned event stream.\nSee EventHandlerOptions for more details.",
              "label": "",
              "type": "EventHandlerOptions",
              "longType": "happyco.type.v1.EventHandlerOptions",
              "fullType": "happyco.type.v1.EventHandlerOptions",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Signatory",
          "longName": "Signatory",
          "fullName": "happyco.inspect.report.v1.Signatory",
          "description": "Signatory represents a signature box on a report",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "name",
              "description": "Name of the signatory. e.g. Mafalda Hopkirk.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "role",
              "description": "TODO: should this be included? Its not included in the report.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "generated_at",
              "description": "Generated is the time when the signatory box was generated and\nattached to the report.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "signed_at",
              "description": "Signed at is the time (as reported by the mobile device) that the\nuser physically signed the report.",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "user_signed_at",
              "description": "User signed at is a user adjustable signed at time (similar to the\ndate field often found on paper reports).",
              "label": "",
              "type": "DateTime",
              "longType": "happyco.type.v1.DateTime",
              "fullType": "happyco.type.v1.DateTime",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": [
        {
          "name": "ReportEventService",
          "longName": "ReportEventService",
          "fullName": "happyco.inspect.report.v1.ReportEventService",
          "description": "ReportEventService is the simplest way to be notified of reports being\ncreated Any number of clients can connect to the service and be pushed the\nevents. HappyCo guarantees to only send one client the event at a time (in a\nround robin fashion). This means that you can scale event processing as\neasily as your web servers.\n\nFor this to work events must be acknowledged or time extensions requested\nbefore the timeout peroid. If neither of these occurs, the event will be\nsent to a new client. This covers 99% of cases, but if it's essential that\nin the event of a frozen client (that unfreezes) that the event is not sent\nto another client. You can de-duplicate requests using the event ID.\n\nWhen selecting a timeout and possible requesting time extensions please be\nwary of network travel time. We recommend setting large timeouts (10mins+)\nunless there is a critical reason to be resent events faster.",
          "methods": [
            {
              "name": "OnReportsCreated",
              "description": "On reports created returns a stream that will be pushed events as\nthey occur",
              "requestType": "ReportsCreatedEventRequest",
              "requestLongType": "ReportsCreatedEventRequest",
              "requestFullType": "happyco.inspect.report.v1.ReportsCreatedEventRequest",
              "requestStreaming": false,
              "responseType": "ReportsCreatedEvent",
              "responseLongType": "ReportsCreatedEvent",
              "responseFullType": "happyco.inspect.report.v1.ReportsCreatedEvent",
              "responseStreaming": true
            },
            {
              "name": "OnReportsCreatedAck",
              "description": "On reports created ack should be called when events have\nbeen processed. Unless this is called events will be sent again\nafter the timeout period.",
              "requestType": "ReportsCreatedEventAck",
              "requestLongType": "ReportsCreatedEventAck",
              "requestFullType": "happyco.inspect.report.v1.ReportsCreatedEventAck",
              "requestStreaming": false,
              "responseType": "ReportsCreatedEventAckResponse",
              "responseLongType": "ReportsCreatedEventAckResponse",
              "responseFullType": "happyco.inspect.report.v1.ReportsCreatedEventAckResponse",
              "responseStreaming": false
            }
          ]
        },
        {
          "name": "ReportService",
          "longName": "ReportService",
          "fullName": "happyco.inspect.report.v1.ReportService",
          "description": "Report service is used for acceing reports generated from\none or two inspections that are linked to the same asset.",
          "methods": [
            {
              "name": "ListReports",
              "description": "List reports gets a paginated and optionally filtered list of\nreports from one or more folders.",
              "requestType": "ListReportsRequest",
              "requestLongType": "ListReportsRequest",
              "requestFullType": "happyco.inspect.report.v1.ListReportsRequest",
              "requestStreaming": false,
              "responseType": "ListReportsResponse",
              "responseLongType": "ListReportsResponse",
              "responseFullType": "happyco.inspect.report.v1.ListReportsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/inspect/reports/list",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "name": "happyco/api/public/type/v1/varia.proto",
      "description": "",
      "package": "happyco.type.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": false,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "FloatArray",
          "longName": "FloatArray",
          "fullName": "happyco.type.v1.FloatArray",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "values",
              "description": "",
              "label": "repeated",
              "type": "float",
              "longType": "float",
              "fullType": "float",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "StringArray",
          "longName": "StringArray",
          "fullName": "happyco.type.v1.StringArray",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "values",
              "description": "",
              "label": "repeated",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": []
    },
    {
      "name": "happyco/api/public/type/v1/date.proto",
      "description": "",
      "package": "happyco.type.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": false,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "Date",
          "longName": "Date",
          "fullName": "happyco.type.v1.Date",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "year",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "month",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "day",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "DateTime",
          "longName": "DateTime",
          "fullName": "happyco.type.v1.DateTime",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "year",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "month",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "day",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "hour24",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "minute",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "second",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": []
    },
    {
      "name": "happyco/api/public/type/v1/event.proto",
      "description": "",
      "package": "happyco.type.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": false,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "Event",
          "longName": "Event",
          "fullName": "happyco.type.v1.Event",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "EventAck",
          "longName": "EventAck",
          "fullName": "happyco.type.v1.EventAck",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": true,
          "extensions": [],
          "fields": [
            {
              "name": "event_ids",
              "description": "",
              "label": "repeated",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "ack",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "ack_message",
              "defaultValue": ""
            },
            {
              "name": "extend_timeout_seconds",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "ack_message",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "EventHandlerOptions",
          "longName": "EventHandlerOptions",
          "fullName": "happyco.type.v1.EventHandlerOptions",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "ack_timeout_seconds",
              "description": "",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": []
    },
    {
      "name": "happyco/api/public/type/v1/integration_id.proto",
      "description": "",
      "package": "happyco.type.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": false,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "IntegrationID",
          "longName": "IntegrationID",
          "fullName": "happyco.type.v1.IntegrationID",
          "description": "IntegrationID represents an object on HappyCo's platform. Use of the\nexternal_id is encouraged as no guarantees are made about id over the life\nof the platform.",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "external_id",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "sync_token",
              "description": "IntegrationData data = 4;",
              "label": "",
              "type": "int32",
              "longType": "int32",
              "fullType": "int32",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": []
    },
    {
      "name": "happyco/api/public/type/v1/paging.proto",
      "description": "",
      "package": "happyco.type.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": false,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "Paging",
          "longName": "Paging",
          "fullName": "happyco.type.v1.Paging",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "PagingResponse",
          "longName": "PagingResponse",
          "fullName": "happyco.type.v1.PagingResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        }
      ],
      "services": []
    },
    {
      "name": "happyco/api/public/manage/asset/v1/asset.proto",
      "description": "",
      "package": "happyco.manage.asset.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "AddAssetPhotoRequest",
          "longName": "AddAssetPhotoRequest",
          "fullName": "happyco.manage.asset.v1.AddAssetPhotoRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "file_name",
              "description": "File name must include a valid image extension.",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "data",
              "description": "Data should contain the image data.",
              "label": "",
              "type": "bytes",
              "longType": "bytes",
              "fullType": "bytes",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AddAssetPhotoResponse",
          "longName": "AddAssetPhotoResponse",
          "fullName": "happyco.manage.asset.v1.AddAssetPhotoResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "photo_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Asset",
          "longName": "Asset",
          "fullName": "happyco.manage.asset.v1.Asset",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": true,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "archived",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "address_line_1",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "address_line_2",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "city",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "state",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "postal_code",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "country",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "unit",
              "description": "",
              "label": "",
              "type": "Unit",
              "longType": "Unit",
              "fullType": "happyco.manage.asset.v1.Unit",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "type",
              "defaultValue": ""
            },
            {
              "name": "property",
              "description": "",
              "label": "",
              "type": "Property",
              "longType": "Property",
              "fullType": "happyco.manage.asset.v1.Property",
              "ismap": false,
              "isoneof": true,
              "oneofdecl": "type",
              "defaultValue": ""
            },
            {
              "name": "photo_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "notes",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "metadata",
              "description": "",
              "label": "repeated",
              "type": "MetadataEntry",
              "longType": "Asset.MetadataEntry",
              "fullType": "happyco.manage.asset.v1.Asset.MetadataEntry",
              "ismap": true,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "MetadataEntry",
          "longName": "Asset.MetadataEntry",
          "fullName": "happyco.manage.asset.v1.Asset.MetadataEntry",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "value",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateAssetsRequest",
          "longName": "CreateAssetsRequest",
          "fullName": "happyco.manage.asset.v1.CreateAssetsRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "assets",
              "description": "",
              "label": "repeated",
              "type": "Asset",
              "longType": "Asset",
              "fullType": "happyco.manage.asset.v1.Asset",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateAssetsResponse",
          "longName": "CreateAssetsResponse",
          "fullName": "happyco.manage.asset.v1.CreateAssetsResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "asset_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListAssetsRequest",
          "longName": "ListAssetsRequest",
          "fullName": "happyco.manage.asset.v1.ListAssetsRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "include_archived",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListAssetsResponse",
          "longName": "ListAssetsResponse",
          "fullName": "happyco.manage.asset.v1.ListAssetsResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "assets",
              "description": "",
              "label": "repeated",
              "type": "Asset",
              "longType": "Asset",
              "fullType": "happyco.manage.asset.v1.Asset",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "PagingResponse",
              "longType": "happyco.type.v1.PagingResponse",
              "fullType": "happyco.type.v1.PagingResponse",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Property",
          "longName": "Property",
          "fullName": "happyco.manage.asset.v1.Property",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "key_number",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SetAssetsArchivedRequest",
          "longName": "SetAssetsArchivedRequest",
          "fullName": "happyco.manage.asset.v1.SetAssetsArchivedRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "asset_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "SetAssetsArchivedResponse",
          "longName": "SetAssetsArchivedResponse",
          "fullName": "happyco.manage.asset.v1.SetAssetsArchivedResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "Unit",
          "longName": "Unit",
          "fullName": "happyco.manage.asset.v1.Unit",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "building",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "floor_plan",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateAssetsRequest",
          "longName": "UpdateAssetsRequest",
          "fullName": "happyco.manage.asset.v1.UpdateAssetsRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "assets",
              "description": "",
              "label": "repeated",
              "type": "Asset",
              "longType": "Asset",
              "fullType": "happyco.manage.asset.v1.Asset",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateAssetsResponse",
          "longName": "UpdateAssetsResponse",
          "fullName": "happyco.manage.asset.v1.UpdateAssetsResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        }
      ],
      "services": [
        {
          "name": "AssetService",
          "longName": "AssetService",
          "fullName": "happyco.manage.asset.v1.AssetService",
          "description": "",
          "methods": [
            {
              "name": "ListAssets",
              "description": "",
              "requestType": "ListAssetsRequest",
              "requestLongType": "ListAssetsRequest",
              "requestFullType": "happyco.manage.asset.v1.ListAssetsRequest",
              "requestStreaming": false,
              "responseType": "ListAssetsResponse",
              "responseLongType": "ListAssetsResponse",
              "responseFullType": "happyco.manage.asset.v1.ListAssetsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/assets/list",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "CreateAssets",
              "description": "",
              "requestType": "CreateAssetsRequest",
              "requestLongType": "CreateAssetsRequest",
              "requestFullType": "happyco.manage.asset.v1.CreateAssetsRequest",
              "requestStreaming": false,
              "responseType": "CreateAssetsResponse",
              "responseLongType": "CreateAssetsResponse",
              "responseFullType": "happyco.manage.asset.v1.CreateAssetsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/assets/create",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateAssets",
              "description": "",
              "requestType": "UpdateAssetsRequest",
              "requestLongType": "UpdateAssetsRequest",
              "requestFullType": "happyco.manage.asset.v1.UpdateAssetsRequest",
              "requestStreaming": false,
              "responseType": "UpdateAssetsResponse",
              "responseLongType": "UpdateAssetsResponse",
              "responseFullType": "happyco.manage.asset.v1.UpdateAssetsResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/assets/update",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "ArchiveAssets",
              "description": "",
              "requestType": "SetAssetsArchivedRequest",
              "requestLongType": "SetAssetsArchivedRequest",
              "requestFullType": "happyco.manage.asset.v1.SetAssetsArchivedRequest",
              "requestStreaming": false,
              "responseType": "SetAssetsArchivedResponse",
              "responseLongType": "SetAssetsArchivedResponse",
              "responseFullType": "happyco.manage.asset.v1.SetAssetsArchivedResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/assets/archive",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UnarchiveAssets",
              "description": "",
              "requestType": "SetAssetsArchivedRequest",
              "requestLongType": "SetAssetsArchivedRequest",
              "requestFullType": "happyco.manage.asset.v1.SetAssetsArchivedRequest",
              "requestStreaming": false,
              "responseType": "SetAssetsArchivedResponse",
              "responseLongType": "SetAssetsArchivedResponse",
              "responseFullType": "happyco.manage.asset.v1.SetAssetsArchivedResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/assets/unarchive",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "AddAssetPhoto",
              "description": "",
              "requestType": "AddAssetPhotoRequest",
              "requestLongType": "AddAssetPhotoRequest",
              "requestFullType": "happyco.manage.asset.v1.AddAssetPhotoRequest",
              "requestStreaming": false,
              "responseType": "AddAssetPhotoResponse",
              "responseLongType": "AddAssetPhotoResponse",
              "responseFullType": "happyco.manage.asset.v1.AddAssetPhotoResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/asset/photo/add",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "name": "happyco/api/public/manage/account_provisioning/v1/account_provisioning.proto",
      "description": "",
      "package": "happyco.manage.account_provisioning.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "CreateAccountsRequest",
          "longName": "CreateAccountsRequest",
          "fullName": "happyco.manage.account_provisioning.v1.CreateAccountsRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_with_admins",
              "description": "",
              "label": "repeated",
              "type": "AccountWithAdmin",
              "longType": "CreateAccountsRequest.AccountWithAdmin",
              "fullType": "happyco.manage.account_provisioning.v1.CreateAccountsRequest.AccountWithAdmin",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AccountWithAdmin",
          "longName": "CreateAccountsRequest.AccountWithAdmin",
          "fullName": "happyco.manage.account_provisioning.v1.CreateAccountsRequest.AccountWithAdmin",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account",
              "description": "",
              "label": "",
              "type": "Account",
              "longType": "happyco.manage.account.v1.Account",
              "fullType": "happyco.manage.account.v1.Account",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "admin",
              "description": "",
              "label": "",
              "type": "User",
              "longType": "happyco.manage.account.v1.User",
              "fullType": "happyco.manage.account.v1.User",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateAccountsResponse",
          "longName": "CreateAccountsResponse",
          "fullName": "happyco.manage.account_provisioning.v1.CreateAccountsResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id_with_admin_ids",
              "description": "",
              "label": "repeated",
              "type": "AccountIDWithAdminID",
              "longType": "CreateAccountsResponse.AccountIDWithAdminID",
              "fullType": "happyco.manage.account_provisioning.v1.CreateAccountsResponse.AccountIDWithAdminID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AccountIDWithAdminID",
          "longName": "CreateAccountsResponse.AccountIDWithAdminID",
          "fullName": "happyco.manage.account_provisioning.v1.CreateAccountsResponse.AccountIDWithAdminID",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "admin_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateAccountStatusesRequest",
          "longName": "UpdateAccountStatusesRequest",
          "fullName": "happyco.manage.account_provisioning.v1.UpdateAccountStatusesRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "active",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateAccountStatusesResponse",
          "longName": "UpdateAccountStatusesResponse",
          "fullName": "happyco.manage.account_provisioning.v1.UpdateAccountStatusesResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        }
      ],
      "services": [
        {
          "name": "AccountProvisioningService",
          "longName": "AccountProvisioningService",
          "fullName": "happyco.manage.account_provisioning.v1.AccountProvisioningService",
          "description": "",
          "methods": [
            {
              "name": "CreateAccounts",
              "description": "No longer supported since version 2.7.",
              "requestType": "CreateAccountsRequest",
              "requestLongType": "CreateAccountsRequest",
              "requestFullType": "happyco.manage.account_provisioning.v1.CreateAccountsRequest",
              "requestStreaming": false,
              "responseType": "CreateAccountsResponse",
              "responseLongType": "CreateAccountsResponse",
              "responseFullType": "happyco.manage.account_provisioning.v1.CreateAccountsResponse",
              "responseStreaming": false,
              "options": {
                "deprecated": true,
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/accounts/create",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateAccountStatuses",
              "description": "No longer supported since version 2.7.",
              "requestType": "UpdateAccountStatusesRequest",
              "requestLongType": "UpdateAccountStatusesRequest",
              "requestFullType": "happyco.manage.account_provisioning.v1.UpdateAccountStatusesRequest",
              "requestStreaming": false,
              "responseType": "UpdateAccountStatusesResponse",
              "responseLongType": "UpdateAccountStatusesResponse",
              "responseFullType": "happyco.manage.account_provisioning.v1.UpdateAccountStatusesResponse",
              "responseStreaming": false,
              "options": {
                "deprecated": true,
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/account/statuses/update",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "name": "happyco/api/public/manage/folder/v1/folder.proto",
      "description": "",
      "package": "happyco.manage.folder.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [
        {
          "name": "Type",
          "longName": "Folder.Type",
          "fullName": "happyco.manage.folder.v1.Folder.Type",
          "description": "",
          "values": [
            {
              "name": "MULTI_FAMILY",
              "number": "0",
              "description": ""
            },
            {
              "name": "PROPERTY_MANAGEMENT",
              "number": "1",
              "description": ""
            }
          ]
        }
      ],
      "extensions": [],
      "messages": [
        {
          "name": "CreateFoldersRequest",
          "longName": "CreateFoldersRequest",
          "fullName": "happyco.manage.folder.v1.CreateFoldersRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folders",
              "description": "",
              "label": "repeated",
              "type": "Folder",
              "longType": "Folder",
              "fullType": "happyco.manage.folder.v1.Folder",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "CreateFoldersResponse",
          "longName": "CreateFoldersResponse",
          "fullName": "happyco.manage.folder.v1.CreateFoldersResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "folder_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "Folder",
          "longName": "Folder",
          "fullName": "happyco.manage.folder.v1.Folder",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "type",
              "description": "",
              "label": "",
              "type": "Type",
              "longType": "Folder.Type",
              "fullType": "happyco.manage.folder.v1.Folder.Type",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListFoldersRequest",
          "longName": "ListFoldersRequest",
          "fullName": "happyco.manage.folder.v1.ListFoldersRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "include_inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListFoldersResponse",
          "longName": "ListFoldersResponse",
          "fullName": "happyco.manage.folder.v1.ListFoldersResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "folders",
              "description": "",
              "label": "repeated",
              "type": "Folder",
              "longType": "Folder",
              "fullType": "happyco.manage.folder.v1.Folder",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "PagingResponse",
              "longType": "happyco.type.v1.PagingResponse",
              "fullType": "happyco.type.v1.PagingResponse",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateFolderStatusesRequest",
          "longName": "UpdateFolderStatusesRequest",
          "fullName": "happyco.manage.folder.v1.UpdateFolderStatusesRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folder_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateFolderStatusesResponse",
          "longName": "UpdateFolderStatusesResponse",
          "fullName": "happyco.manage.folder.v1.UpdateFolderStatusesResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "UpdateFoldersRequest",
          "longName": "UpdateFoldersRequest",
          "fullName": "happyco.manage.folder.v1.UpdateFoldersRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "folders",
              "description": "",
              "label": "repeated",
              "type": "Folder",
              "longType": "Folder",
              "fullType": "happyco.manage.folder.v1.Folder",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateFoldersResponse",
          "longName": "UpdateFoldersResponse",
          "fullName": "happyco.manage.folder.v1.UpdateFoldersResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": [
        {
          "name": "FolderService",
          "longName": "FolderService",
          "fullName": "happyco.manage.folder.v1.FolderService",
          "description": "",
          "methods": [
            {
              "name": "ListFolders",
              "description": "",
              "requestType": "ListFoldersRequest",
              "requestLongType": "ListFoldersRequest",
              "requestFullType": "happyco.manage.folder.v1.ListFoldersRequest",
              "requestStreaming": false,
              "responseType": "ListFoldersResponse",
              "responseLongType": "ListFoldersResponse",
              "responseFullType": "happyco.manage.folder.v1.ListFoldersResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/folders/list",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "CreateFolders",
              "description": "",
              "requestType": "CreateFoldersRequest",
              "requestLongType": "CreateFoldersRequest",
              "requestFullType": "happyco.manage.folder.v1.CreateFoldersRequest",
              "requestStreaming": false,
              "responseType": "CreateFoldersResponse",
              "responseLongType": "CreateFoldersResponse",
              "responseFullType": "happyco.manage.folder.v1.CreateFoldersResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/folders/create",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateFolders",
              "description": "",
              "requestType": "UpdateFoldersRequest",
              "requestLongType": "UpdateFoldersRequest",
              "requestFullType": "happyco.manage.folder.v1.UpdateFoldersRequest",
              "requestStreaming": false,
              "responseType": "UpdateFoldersResponse",
              "responseLongType": "UpdateFoldersResponse",
              "responseFullType": "happyco.manage.folder.v1.UpdateFoldersResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/folders/update",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateFolderStatuses",
              "description": "",
              "requestType": "UpdateFolderStatusesRequest",
              "requestLongType": "UpdateFolderStatusesRequest",
              "requestFullType": "happyco.manage.folder.v1.UpdateFolderStatusesRequest",
              "requestStreaming": false,
              "responseType": "UpdateFolderStatusesResponse",
              "responseLongType": "UpdateFolderStatusesResponse",
              "responseFullType": "happyco.manage.folder.v1.UpdateFolderStatusesResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/folder/statuses/update",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    },
    {
      "name": "happyco/api/public/manage/account/v1/account.proto",
      "description": "",
      "package": "happyco.manage.account.v1",
      "hasEnums": false,
      "hasExtensions": false,
      "hasMessages": true,
      "hasServices": true,
      "enums": [],
      "extensions": [],
      "messages": [
        {
          "name": "Account",
          "longName": "Account",
          "fullName": "happyco.manage.account.v1.Account",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "phone",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "address_line_1",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "address_line_2",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "city",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "state",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "postal_code",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "country",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AddUsersRequest",
          "longName": "AddUsersRequest",
          "fullName": "happyco.manage.account.v1.AddUsersRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "users",
              "description": "",
              "label": "repeated",
              "type": "User",
              "longType": "User",
              "fullType": "happyco.manage.account.v1.User",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AddUsersResponse",
          "longName": "AddUsersResponse",
          "fullName": "happyco.manage.account.v1.AddUsersResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "user_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListAccountsRequest",
          "longName": "ListAccountsRequest",
          "fullName": "happyco.manage.account.v1.ListAccountsRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "include_inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListAccountsResponse",
          "longName": "ListAccountsResponse",
          "fullName": "happyco.manage.account.v1.ListAccountsResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "accounts",
              "description": "",
              "label": "repeated",
              "type": "Account",
              "longType": "Account",
              "fullType": "happyco.manage.account.v1.Account",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "PagingResponse",
              "longType": "happyco.type.v1.PagingResponse",
              "fullType": "happyco.type.v1.PagingResponse",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListUsersRequest",
          "longName": "ListUsersRequest",
          "fullName": "happyco.manage.account.v1.ListUsersRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "user_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "include_inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "Paging",
              "longType": "happyco.type.v1.Paging",
              "fullType": "happyco.type.v1.Paging",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "ListUsersResponse",
          "longName": "ListUsersResponse",
          "fullName": "happyco.manage.account.v1.ListUsersResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "users",
              "description": "",
              "label": "repeated",
              "type": "User",
              "longType": "User",
              "fullType": "happyco.manage.account.v1.User",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "paging",
              "description": "",
              "label": "",
              "type": "PagingResponse",
              "longType": "happyco.type.v1.PagingResponse",
              "fullType": "happyco.type.v1.PagingResponse",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateAccountsRequest",
          "longName": "UpdateAccountsRequest",
          "fullName": "happyco.manage.account.v1.UpdateAccountsRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_with_admin_ids",
              "description": "",
              "label": "repeated",
              "type": "AccountWithAdminId",
              "longType": "UpdateAccountsRequest.AccountWithAdminId",
              "fullType": "happyco.manage.account.v1.UpdateAccountsRequest.AccountWithAdminId",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "AccountWithAdminId",
          "longName": "UpdateAccountsRequest.AccountWithAdminId",
          "fullName": "happyco.manage.account.v1.UpdateAccountsRequest.AccountWithAdminId",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account",
              "description": "",
              "label": "",
              "type": "Account",
              "longType": "Account",
              "fullType": "happyco.manage.account.v1.Account",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "admin_user_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateAccountsResponse",
          "longName": "UpdateAccountsResponse",
          "fullName": "happyco.manage.account.v1.UpdateAccountsResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "UpdateUserStatusesRequest",
          "longName": "UpdateUserStatusesRequest",
          "fullName": "happyco.manage.account.v1.UpdateUserStatusesRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "user_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "active",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateUserStatusesResponse",
          "longName": "UpdateUserStatusesResponse",
          "fullName": "happyco.manage.account.v1.UpdateUserStatusesResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": false,
          "hasOneofs": false,
          "extensions": [],
          "fields": []
        },
        {
          "name": "UpdateUsersRequest",
          "longName": "UpdateUsersRequest",
          "fullName": "happyco.manage.account.v1.UpdateUsersRequest",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "account_id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "users",
              "description": "",
              "label": "repeated",
              "type": "User",
              "longType": "User",
              "fullType": "happyco.manage.account.v1.User",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "UpdateUsersResponse",
          "longName": "UpdateUsersResponse",
          "fullName": "happyco.manage.account.v1.UpdateUsersResponse",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "user_ids",
              "description": "",
              "label": "repeated",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        },
        {
          "name": "User",
          "longName": "User",
          "fullName": "happyco.manage.account.v1.User",
          "description": "",
          "hasExtensions": false,
          "hasFields": true,
          "hasOneofs": false,
          "extensions": [],
          "fields": [
            {
              "name": "id",
              "description": "",
              "label": "",
              "type": "IntegrationID",
              "longType": "happyco.type.v1.IntegrationID",
              "fullType": "happyco.type.v1.IntegrationID",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "inactive",
              "description": "",
              "label": "",
              "type": "bool",
              "longType": "bool",
              "fullType": "bool",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "first_name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "last_name",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "email",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            },
            {
              "name": "phone",
              "description": "",
              "label": "",
              "type": "string",
              "longType": "string",
              "fullType": "string",
              "ismap": false,
              "isoneof": false,
              "oneofdecl": "",
              "defaultValue": ""
            }
          ]
        }
      ],
      "services": [
        {
          "name": "AccountService",
          "longName": "AccountService",
          "fullName": "happyco.manage.account.v1.AccountService",
          "description": "",
          "methods": [
            {
              "name": "ListAccounts",
              "description": "No longer supported since version 2.7.",
              "requestType": "ListAccountsRequest",
              "requestLongType": "ListAccountsRequest",
              "requestFullType": "happyco.manage.account.v1.ListAccountsRequest",
              "requestStreaming": false,
              "responseType": "ListAccountsResponse",
              "responseLongType": "ListAccountsResponse",
              "responseFullType": "happyco.manage.account.v1.ListAccountsResponse",
              "responseStreaming": false,
              "options": {
                "deprecated": true,
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/accounts/list",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateAccounts",
              "description": "No longer supported since version 2.7.",
              "requestType": "UpdateAccountsRequest",
              "requestLongType": "UpdateAccountsRequest",
              "requestFullType": "happyco.manage.account.v1.UpdateAccountsRequest",
              "requestStreaming": false,
              "responseType": "UpdateAccountsResponse",
              "responseLongType": "UpdateAccountsResponse",
              "responseFullType": "happyco.manage.account.v1.UpdateAccountsResponse",
              "responseStreaming": false,
              "options": {
                "deprecated": true,
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/accounts/update",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        },
        {
          "name": "AccountUsersService",
          "longName": "AccountUsersService",
          "fullName": "happyco.manage.account.v1.AccountUsersService",
          "description": "",
          "methods": [
            {
              "name": "ListUsers",
              "description": "",
              "requestType": "ListUsersRequest",
              "requestLongType": "ListUsersRequest",
              "requestFullType": "happyco.manage.account.v1.ListUsersRequest",
              "requestStreaming": false,
              "responseType": "ListUsersResponse",
              "responseLongType": "ListUsersResponse",
              "responseFullType": "happyco.manage.account.v1.ListUsersResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/account/users/list",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "AddUsers",
              "description": "Add users uses email to create or look up a user and add them to the specified\naccount. As of version 2.7, it no longer creates inactive users.",
              "requestType": "AddUsersRequest",
              "requestLongType": "AddUsersRequest",
              "requestFullType": "happyco.manage.account.v1.AddUsersRequest",
              "requestStreaming": false,
              "responseType": "AddUsersResponse",
              "responseLongType": "AddUsersResponse",
              "responseFullType": "happyco.manage.account.v1.AddUsersResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "POST",
                      "pattern": "/api/v1/manage/account/users/add",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateUsers",
              "description": "",
              "requestType": "UpdateUsersRequest",
              "requestLongType": "UpdateUsersRequest",
              "requestFullType": "happyco.manage.account.v1.UpdateUsersRequest",
              "requestStreaming": false,
              "responseType": "UpdateUsersResponse",
              "responseLongType": "UpdateUsersResponse",
              "responseFullType": "happyco.manage.account.v1.UpdateUsersResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/account/users/update",
                      "body": "*"
                    }
                  ]
                }
              }
            },
            {
              "name": "UpdateUserStatuses",
              "description": "",
              "requestType": "UpdateUserStatusesRequest",
              "requestLongType": "UpdateUserStatusesRequest",
              "requestFullType": "happyco.manage.account.v1.UpdateUserStatusesRequest",
              "requestStreaming": false,
              "responseType": "UpdateUserStatusesResponse",
              "responseLongType": "UpdateUserStatusesResponse",
              "responseFullType": "happyco.manage.account.v1.UpdateUserStatusesResponse",
              "responseStreaming": false,
              "options": {
                "google.api.http": {
                  "rules": [
                    {
                      "method": "PUT",
                      "pattern": "/api/v1/manage/account/user/statuses/update",
                      "body": "*"
                    }
                  ]
                }
              }
            }
          ]
        }
      ]
    }
  ],
  "scalarValueTypes": [
    {
      "protoType": "double",
      "notes": "",
      "cppType": "double",
      "csType": "double",
      "goType": "float64",
      "javaType": "double",
      "phpType": "float",
      "pythonType": "float",
      "rubyType": "Float"
    },
    {
      "protoType": "float",
      "notes": "",
      "cppType": "float",
      "csType": "float",
      "goType": "float32",
      "javaType": "float",
      "phpType": "float",
      "pythonType": "float",
      "rubyType": "Float"
    },
    {
      "protoType": "int32",
      "notes": "Uses variable-length encoding. Inefficient for encoding negative numbers – if your field is likely to have negative values, use sint32 instead.",
      "cppType": "int32",
      "csType": "int",
      "goType": "int32",
      "javaType": "int",
      "phpType": "integer",
      "pythonType": "int",
      "rubyType": "Bignum or Fixnum (as required)"
    },
    {
      "protoType": "int64",
      "notes": "Uses variable-length encoding. Inefficient for encoding negative numbers – if your field is likely to have negative values, use sint64 instead.",
      "cppType": "int64",
      "csType": "long",
      "goType": "int64",
      "javaType": "long",
      "phpType": "integer/string",
      "pythonType": "int/long",
      "rubyType": "Bignum"
    },
    {
      "protoType": "uint32",
      "notes": "Uses variable-length encoding.",
      "cppType": "uint32",
      "csType": "uint",
      "goType": "uint32",
      "javaType": "int",
      "phpType": "integer",
      "pythonType": "int/long",
      "rubyType": "Bignum or Fixnum (as required)"
    },
    {
      "protoType": "uint64",
      "notes": "Uses variable-length encoding.",
      "cppType": "uint64",
      "csType": "ulong",
      "goType": "uint64",
      "javaType": "long",
      "phpType": "integer/string",
      "pythonType": "int/long",
      "rubyType": "Bignum or Fixnum (as required)"
    },
    {
      "protoType": "sint32",
      "notes": "Uses variable-length encoding. Signed int value. These more efficiently encode negative numbers than regular int32s.",
      "cppType": "int32",
      "csType": "int",
      "goType": "int32",
      "javaType": "int",
      "phpType": "integer",
      "pythonType": "int",
      "rubyType": "Bignum or Fixnum (as required)"
    },
    {
      "protoType": "sint64",
      "notes": "Uses variable-length encoding. Signed int value. These more efficiently encode negative numbers than regular int64s.",
      "cppType": "int64",
      "csType": "long",
      "goType": "int64",
      "javaType": "long",
      "phpType": "integer/string",
      "pythonType": "int/long",
      "rubyType": "Bignum"
    },
    {
      "protoType": "fixed32",
      "notes": "Always four bytes. More efficient than uint32 if values are often greater than 2^28.",
      "cppType": "uint32",
      "csType": "uint",
      "goType": "uint32",
      "javaType": "int",
      "phpType": "integer",
      "pythonType": "int",
      "rubyType": "Bignum or Fixnum (as required)"
    },
    {
      "protoType": "fixed64",
      "notes": "Always eight bytes. More efficient than uint64 if values are often greater than 2^56.",
      "cppType": "uint64",
      "csType": "ulong",
      "goType": "uint64",
      "javaType": "long",
      "phpType": "integer/string",
      "pythonType": "int/long",
      "rubyType": "Bignum"
    },
    {
      "protoType": "sfixed32",
      "notes": "Always four bytes.",
      "cppType": "int32",
      "csType": "int",
      "goType": "int32",
      "javaType": "int",
      "phpType": "integer",
      "pythonType": "int",
      "rubyType": "Bignum or Fixnum (as required)"
    },
    {
      "protoType": "sfixed64",
      "notes": "Always eight bytes.",
      "cppType": "int64",
      "csType": "long",
      "goType": "int64",
      "javaType": "long",
      "phpType": "integer/string",
      "pythonType": "int/long",
      "rubyType": "Bignum"
    },
    {
      "protoType": "bool",
      "notes": "",
      "cppType": "bool",
      "csType": "bool",
      "goType": "bool",
      "javaType": "boolean",
      "phpType": "boolean",
      "pythonType": "boolean",
      "rubyType": "TrueClass/FalseClass"
    },
    {
      "protoType": "string",
      "notes": "A string must always contain UTF-8 encoded or 7-bit ASCII text.",
      "cppType": "string",
      "csType": "string",
      "goType": "string",
      "javaType": "String",
      "phpType": "string",
      "pythonType": "str/unicode",
      "rubyType": "String (UTF-8)"
    },
    {
      "protoType": "bytes",
      "notes": "May contain any arbitrary sequence of bytes.",
      "cppType": "string",
      "csType": "ByteString",
      "goType": "[]byte",
      "javaType": "ByteString",
      "phpType": "string",
      "pythonType": "str",
      "rubyType": "String (ASCII-8BIT)"
    }
  ]
};

export default api;



// WEBPACK FOOTER //
// ./src/reference/content/_generated.js